import { AbiEvent } from 'ox';
import { htlcEvents } from '../abi.js';
import { hex } from '../utils.js';
export function findUserLockedEvent(logs, matchHashlock) {
    for (const log of logs) {
        try {
            const decoded = AbiEvent.decode(htlcEvents.UserLocked, {
                data: hex(log.data),
                topics: log.topics,
            });
            if (!matchHashlock || decoded.hashlock === matchHashlock) {
                return decoded;
            }
        }
        catch {
            // Not a UserLocked event — skip
        }
    }
    return null;
}
